import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import GenerationForm from '../components/GenerationForm';
import ResultViewer from '../components/ResultViewer';

const HomePage = () => {
  const { user, logout } = useAuth();
  // Change from single job to array of jobs
  const [generationJobs, setGenerationJobs] = useState([]);
  const [avatarError, setAvatarError] = useState(false);

  const handleGenerationSubmit = (jobData) => {
    // Add new job to the beginning of the array
    setGenerationJobs(prevJobs => [jobData, ...prevJobs]);
  };

  // Function to get initials from name
  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>AI Video Generation</h1>
        <div className="user-info">
          {user && user.picture && !avatarError ? (
            <img 
              src={user.picture} 
              alt={`${user.name}'s avatar`} 
              className="user-avatar"
              onError={() => {
                console.log('Avatar failed to load, using initials');
                setAvatarError(true);
              }}
            />
          ) : (
            <div className="user-avatar-placeholder">
              {getInitials(user?.name || user?.email || '')}
            </div>
          )}
          <span>{user?.name || user?.email}</span>
          <button onClick={logout} className="logout-button">Logout</button>
        </div>
      </header>
      
      <main className="app-main">
        <div className="left-column">
          <GenerationForm onGenerationSubmit={handleGenerationSubmit} />
        </div>
        
        <div className="right-column">
          {generationJobs.length > 0 ? (
            <div className="generations-list">
              {generationJobs.map((job, index) => (
                <div key={job.jobId} className="generation-item">
                  <h3>Generation #{generationJobs.length - index}</h3>
                  <p className="generation-prompt">{job.prompt}</p>
                  <ResultViewer 
                    jobId={job.jobId} 
                    generationType={job.type} 
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="no-generations">
              <p>No generations yet. Fill out the form to create your first video!</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default HomePage;